module.exports = __webpack_public_path__ + "static/fonts/georgiai.4c6c096e.ttf";